import styled from '@emotion/styled';

type BannerVariant = 'hero' | 'compact';

interface VariantProps {
	$variant?: BannerVariant;
}

export const SubBannerContainer = styled.div<{ bgImg: string } & VariantProps>`
	padding: 0;
	min-height: ${({ $variant }) => ($variant === 'compact' ? '22rem' : '48rem')};
	height: 100%;
	color: #fff;
	position: relative;
	overflow: hidden;
	background-image: ${(props) => props.theme.brand.subBannerOverlay}, url(${(props) => props.bgImg});
	background-color: ${(props) => props.theme.colors.brandNavy};
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;

	@media screen and (max-width: 900px) {
		min-height: ${({ $variant }) => ($variant === 'compact' ? '16rem' : '32rem')};
	}
`;

export const TextBoxWrapper = styled.div<VariantProps>`
	position: absolute;
	top: 50%;
	left: 0;
	right: 0;
	transform: translateY(-50%);
	width: 100%;
	max-width: ${(props) => props.theme.scale.contentMaxWidth};
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: ${({ $variant }) => ($variant === 'compact' ? 'flex-start' : 'center')};
	gap: ${({ $variant, theme }) => ($variant === 'compact' ? theme.scale.space2xs : '0.8rem')};
	padding: 0 ${(props) => props.theme.scale.contentPaddingX};
	box-sizing: border-box;

	.sub_title {
		margin: 0;
		text-align: ${({ $variant }) => ($variant === 'compact' ? 'left' : 'center')};
		font-size: ${({ $variant, theme }) => ($variant === 'compact' ? theme.fontSize.sizeSm : theme.fontSize.size5xl)};
		font-weight: ${({ $variant, theme }) => ($variant === 'compact' ? theme.fontWeight.weightSemi : theme.fontWeight.weightBold)};
		line-height: 1.2;
		letter-spacing: ${({ $variant, theme }) => ($variant === 'compact' ? theme.ui.letterSpacing.label : theme.ui.letterSpacing.tight)};
		text-transform: ${({ $variant }) => ($variant === 'compact' ? 'uppercase' : 'none')};
		color: ${(props) => props.theme.ui.text.inverseSoft};
		text-shadow: ${({ $variant }) => ($variant === 'compact' ? 'none' : '0 3px 18px rgba(0, 21, 52, 0.42)')};

		@media screen and (max-width: 900px) {
			font-size: ${({ $variant, theme }) => ($variant === 'compact' ? theme.fontSize.sizeXs : theme.fontSize.size2xl)};
		}
	}

	.title {
		margin: 0;
		color: ${(props) => props.theme.ui.text.inverse};
		text-align: ${({ $variant }) => ($variant === 'compact' ? 'left' : 'center')};
		font-size: ${({ $variant }) => ($variant === 'compact' ? '3.2rem' : '5.2rem')};
		font-weight: ${(props) => props.theme.fontWeight.weightBold};
		line-height: 1.25;
		letter-spacing: ${(props) => props.theme.ui.letterSpacing.body};
		text-shadow: 0 4px 30px rgba(0, 21, 52, 0.5);
		word-break: keep-all;

		@media screen and (max-width: 900px) {
			font-size: ${({ $variant }) => ($variant === 'compact' ? '2.4rem' : '3.6rem')};
		}
	}
`;
